import MainComponent from "./components/MainComponent";
function App() {
  return (
   <div className='app'>
      <MainComponent />
   </div>
  );
}

export default App;
